<template>
    <section>
        <div class="titulo">
            <div class="margem container">
                <h2>Produtos x Categorias de Despesa</h2>
            </div>
        </div>
        <div class="margem container space-y-3">
            <div class="bloco2 margem tree" style="font-size: medium">
                <ul class="tree-root">
                    <template v-for="g in gruposFiltrados" :key="g.id">
                        <li class="tree-node">
                            <div class="row">
                                <span class="node-label" title="Clique para expandir/recolher" @click="toggle(g)">
                                    <i class="fa-regular"
                                        :class="g.expandido ? 'fa-square-caret-down' : 'fa-square-caret-right'"></i>
                                    <span>{{ g.descricaoDRE }}</span>
                                </span>
                            </div>
                            <ul v-if="g.expandido && g.subgrupo?.length" class="tree-children">
                                <li v-for="s in g.subgrupo" :key="s.id" class="tree-node">
                                    <div class="row">
                                        <span class="node-label" :title="`Subgrupo: ${s.descricaoDRE}`"
                                            @click="toggle(s)">
                                            <i class="fa-regular"
                                                :class="s.expandido ? 'fa-square-caret-down' : 'fa-square-caret-right'"></i>
                                            {{ s.descricaoDRE }} </span>
                                    </div>
                                    <ul v-if="s.expandido && s.categoriaDRE?.length" class="tree-children">
                                        <li v-for="c in s.categoriaDRE" :key="c.id" class="tree-node"
                                            v-show="mostraCategoria(c)">
                                            <div class="row">
                                                <span class="node-label" :title="`Categoria: ${c.descricao}`"
                                                    @click="expandirCategoria(c)">
                                                    <i class="fa-regular"
                                                        :class="c.expandido ? 'fa-square-caret-down' : 'fa-square-caret-right'"></i>
                                                    {{ c.descricao }} <small class="badge"
                                                        v-if="c.produtosCarregados">{{ c.produtos?.length || 0
                                                        }}</small>
                                                </span>
                                                <div class="actions" role="toolbar">
                                                    <button class="btn"
                                                        :title="`Adicionar produtos à categoria '${c.descricao}'`"
                                                        @click.stop="abrirModalCategoria(c)">
                                                        <i class="fa-solid fa-plus"></i>
                                                    </button>
                                                </div>
                                            </div>
                                            <ul v-if="c.expandido && produtosVisiveis(c).length"
                                                class="tree-children cat-body">
                                                <li v-for="p in produtosVisiveis(c)" :key="idProd(p)"
                                                    class="produto-item" :title="p.nome || p.desc">
                                                    <span class="produto-nome">• {{ p.cod }} - {{ p.nome || p.desc
                                                    }}</span>
                                                    <div class="actions" role="toolbar">
                                                        <button class="btn acao-secundaria" style="color:red"
                                                            @click.stop="removerProduto(c, p)">
                                                            <i class="fa-solid fa-trash"></i>
                                                        </button>
                                                    </div>
                                                </li>
                                                <li v-if="temMais(c)" class="load-more">
                                                    <button class="btn" @click.stop="carregarMais(c)">Carregar
                                                        mais</button>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                    </template>
                </ul>
            </div>
        </div>
        <ModalProdutos :aberto="modal.aberto" :categoria-alvo="modal.categoriaAlvo"
            :ja-vinculados-ids="idsJaVinculadosDaCategoria" @fechar="fecharModal"
            @confirmar="onConfirmarProdutosSelecionados" />
    </section>
</template>
<script>
import estruturaService from '@/services/estrutura-service';
import produtoService from '@/services/produtos-service';
import ModalProdutos from '@/components/modalProdutos/modalProdutosComponent.vue';

export default {
    name: 'ProdutosCategoriasDRE',
    components: { ModalProdutos },

    data() {
        return {
            grupos: [],
            busca: '',
            somenteComProdutos: false,
            limitePorCat: {},
            passo: 50,
            carregando: false,
            erro: null,
            modal: { aberto: false, categoriaAlvo: null },
        };
    },

    computed: {
        termo() {
            return this.busca.trim().toLowerCase();
        },

        idsJaVinculadosDaCategoria() {
            const c = this.modal.categoriaAlvo;
            return c?.produtos?.map(this.idProd) ?? [];
        },

        gruposFiltrados() {
            if (!this.termo && !this.somenteComProdutos) return this.grupos;
            const match = (s) => String(s ?? '').toLowerCase().includes(this.termo);
            const filtrarGrupo = (g) => {
                const sub = (g.subgrupo || [])
                    .map((s) => {
                        const cats = (s.categoriaDRE || []).filter((c) => {
                            const temProd = (c.produtos?.length || 0) > 0;
                            if (this.somenteComProdutos && !temProd) return false;
                            if (!this.termo) return true;
                            const bateNaCat = match(c.descricao);
                            const bateEmProd = (c.produtos || []).some((p) => match(p.nome || p.desc) || match(p.sku || p.cod));
                            return bateNaCat || bateEmProd;
                        });

                        return (cats.length || match(s.descricaoDRE)) ? { ...s, categoriaDRE: cats } : null;
                    })
                    .filter(Boolean);

                return (sub.length || match(g.descricaoDRE)) ? { ...g, subgrupo: sub } : null;
            };

            return this.grupos.map(filtrarGrupo).filter(Boolean);
        },
    },

    mounted() {
        this.obterEstrutura();
    },

    methods: {
        idProd(p) {
            return p?.produto_cod ?? p?.id ?? p?.cod;
        },

        match(s) {
            return String(s ?? '').toLowerCase().includes(this.termo);
        },

        limiteCat(c) {
            if (this.limitePorCat[c.id] == null) {
                this.$set ? this.$set(this.limitePorCat, c.id, this.passo) : (this.limitePorCat[c.id] = this.passo);
            }
            return this.limitePorCat[c.id];
        },
        toggle(n) {
            n.expandido = !n.expandido;
        },

        mostraCategoria(c) {
            if (!this.somenteComProdutos) return true;
            return (c.produtos?.length || 0) > 0;
        },

        produtosVisiveis(c) {
            const base = c.produtos || [];
            const filtrada = this.termo
                ? base.filter((p) => this.match(p.nome || p.desc) || this.match(p.sku || p.cod))
                : base;
            return filtrada.slice(0, this.limiteCat(c));
        },

        temMais(c) {
            const base = c.produtos || [];
            const total = this.termo
                ? base.filter((p) => this.match(p.nome || p.desc) || this.match(p.sku || p.cod)).length
                : base.length;
            return total > this.limiteCat(c);
        },

        carregarMais(c) {
            this.limitePorCat[c.id] = this.limiteCat(c) + this.passo;
        },

        abrirModalCategoria(c) {
            this.modal = { aberto: true, categoriaAlvo: c };
        },

        fecharModal() {
            this.modal = { aberto: false, categoriaAlvo: null };
        },

        async obterEstrutura(ano) {
            this.carregando = true;
            this.erro = null;
            try {
                const { data } = await estruturaService.obterEstrutura(ano);
                const lista = Array.isArray(data) ? data : [];
                lista.forEach((g) => {
                    g.expandido = false;
                    (g.subgrupo || []).forEach((s) => {
                        s.expandido = false;
                        (s.categoriaDRE || []).forEach((c) => {
                            c.expandido = false;
                            c.produtosCarregados = false;
                            c.produtos = [];
                            this.limiteCat(c);
                        });
                    });
                });

                this.grupos = lista;
            } catch (e) {
                console.error(e);
                this.erro = 'Não foi possível carregar a estrutura.';
            } finally {
                this.carregando = false;
            }
        },

        async expandirCategoria(c) {
            c.expandido = !c.expandido;
            if (!c.expandido || c.produtosCarregados) return;

            try {
                const { data } = await produtoService.listarProdutosCategoria(c.id);
                const itens = Array.isArray(data) ? data : [];
                c.produtos = itens.map((p) => ({
                    id: p.id,
                    produto_cod: p.produto_cod,
                    cod: p.cod,
                    nome: p.desc,
                    tipoProduto_id: p.tipoProduto_id,
                    familia_id: p.familia_id,
                }));
            } catch (e) {
                console.error('Erro ao listar produtos vinculados', e);
                c.produtos = [];
            } finally {
                c.produtosCarregados = true;
                this.limiteCat(c);
            }
        },

        async onConfirmarProdutosSelecionados(selecionados) {
            const c = this.modal.categoriaAlvo;
            if (!c) return;

            try {
                const codigos = (selecionados || []).map(this.idProd).filter(Boolean);
                await produtoService.vincularProdutosCategoria(c.id, codigos);
                c.produtosCarregados = false;
                c.expandido = true;
                await this.expandirCategoria(c);
            } catch (e) {
                console.error('Erro ao vincular produtos:', e);
            } finally {
                this.fecharModal();
            }
        },

        async removerProduto(c, p) {
            try {
                await produtoService.desvincularProdutosCategoria(c.id, [this.idProd(p)]);
                c.produtosCarregados = false;
                c.expandido = true;
                await this.expandirCategoria(c);
            } catch (e) {
                console.error('Erro ao desvincular categoria:', e);
            }
        },
    },
};
</script>
<style scoped>
.tree-root,
.tree-children {
    list-style: none;
    margin: 0;
    padding-left: 18px;
}

.tree-node {
    margin: 6px 0;
}

.row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 6px 4px;
}

.node-label {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    user-select: none;
    cursor: pointer;
}

.actions {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.badge {
    background: #eef2ff;
    border: 1px solid #c7d2fe;
    padding: 2px 6px;
    border-radius: 999px;
    margin-left: 6px;
    font-size: 0.75rem;
}

.produto-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 4px 0;
}

.btn {
    border: 1px solid #d1d5db;
    padding: 6px 10px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 0.875rem;
    display: inline-flex;
    align-items: center;
    gap: 6px;
}
</style>
